import {Injectable} from '@angular/core';
import {AuthManagerService} from "../auth/auth-manager.service";
import {Observable} from "rxjs/internal/Observable";
import {HttpClient} from "@angular/common/http";
import {AppResponse} from "./app-response.model";

@Injectable({
  providedIn: 'root'
})
export class AuthHttpService {

  constructor(private authManager: AuthManagerService, private http: HttpClient) {
  }

  post<T>(relativeUrl: string, body: any, parameters?: any): Observable<AppResponse<T>> {
    return this.authManager.authRequest("POST", relativeUrl, parameters, body);
  }

  postBlob(relativeUrl: string, body: any, parameters?: any): Observable<AppResponse<Blob>> {
    return this.authManager.authRequestBlob("POST", relativeUrl, parameters, body);
  }

  put<T>(relativeUrl: string, body: any, parameters?: any): Observable<AppResponse<T>> {
    return this.authManager.authRequest("PUT", relativeUrl, parameters, body);
  }

  get<T>(relativeUrl: string, parameters?: any): Observable<AppResponse<T>> {
    return this.authManager.authRequest("GET", relativeUrl, parameters);
  }

  delete<T>(relativeUrl: string, parameters?: any): Observable<AppResponse<T>> {
    return this.authManager.authRequest("DELETE", relativeUrl, parameters);
  }

}
